/**
 * Coups de pouce — Attendu 951 « Définir le demi-tour, ou symétrie centrale ».
 * Une entrée par generator_key (cf. gen_951.js).
 */

// ── Construire le symétrique : animation (id cp951play1) ──
// Méthode du trajet : compter les carreaux de A jusqu'au centre C, puis
// continuer le même trajet après C (décision utilisateur 2026-08-13).
// Non recopiable : la réponse d'un exercice dépend de ses propres points.
const SVG_CONSTRUIRE_ANIM = `
<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 360 228" role="img"
     aria-label="Un quadrillage avec un point A bleu et un centre C. Le trajet de A vers C est compté en vert : 2 carreaux à droite, 1 vers le haut. Le même trajet continue après C en orange, et le point D, symétrique de A, apparaît">
  <g id="cp951play1" style="cursor:pointer">
    <title>Lancer l'animation</title>
    <rect x="266" y="4" width="86" height="24" rx="12" fill="#1E3A8A"/>
    <path d="M278 10 L278 22 L288 16 Z" fill="#ffffff"/>
    <text x="322" y="20" font-size="12" font-weight="600" fill="#ffffff" text-anchor="middle" font-family="system-ui,sans-serif">Lancer</text>
  </g>
  <!-- la grille, A et C -->
  <g opacity="0">
    <line x1="15" y1="44" x2="15" y2="174" stroke="#cbd5e1" stroke-width="1"/><line x1="41" y1="44" x2="41" y2="174" stroke="#cbd5e1" stroke-width="1"/><line x1="67" y1="44" x2="67" y2="174" stroke="#cbd5e1" stroke-width="1"/><line x1="93" y1="44" x2="93" y2="174" stroke="#cbd5e1" stroke-width="1"/><line x1="119" y1="44" x2="119" y2="174" stroke="#cbd5e1" stroke-width="1"/><line x1="145" y1="44" x2="145" y2="174" stroke="#cbd5e1" stroke-width="1"/>
    <line x1="15" y1="44" x2="145" y2="44" stroke="#cbd5e1" stroke-width="1"/><line x1="15" y1="70" x2="145" y2="70" stroke="#cbd5e1" stroke-width="1"/><line x1="15" y1="96" x2="145" y2="96" stroke="#cbd5e1" stroke-width="1"/><line x1="15" y1="122" x2="145" y2="122" stroke="#cbd5e1" stroke-width="1"/><line x1="15" y1="148" x2="145" y2="148" stroke="#cbd5e1" stroke-width="1"/><line x1="15" y1="174" x2="145" y2="174" stroke="#cbd5e1" stroke-width="1"/>
    <rect x="15" y="44" width="130" height="130" fill="none" stroke="#1E3A8A" stroke-width="1.4"/>
    <circle cx="15" cy="148" r="4.5" fill="#1E3A8A"/>
    <text x="21" y="142" font-size="12" font-weight="700" fill="#1E3A8A" font-family="system-ui,sans-serif">A</text>
    <circle cx="67" cy="122" r="4" fill="#0f172a"/>
    <text x="60" y="126" font-size="12" font-weight="700" fill="#0f172a" text-anchor="end" font-family="system-ui,sans-serif">C</text>
    <animate attributeName="opacity" values="0;0" dur="0.05s" begin="cp951play1.click" fill="freeze"/>
    <animate attributeName="opacity" values="0;1" dur="0.3s" begin="cp951play1.click+0.3s" fill="freeze"/>
  </g>
  <!-- trajet A -> C (vert) -->
  <g opacity="0">
    <polyline points="15,148 67,148 67,128" fill="none" stroke="#1D9E75" stroke-width="2.4"/>
    <path d="M67,121 L63,129 L71,129 Z" fill="#1D9E75"/>
    <animate attributeName="opacity" values="0;0" dur="0.05s" begin="cp951play1.click" fill="freeze"/>
    <animate attributeName="opacity" values="0;1" dur="0.3s" begin="cp951play1.click+1.6s" fill="freeze"/>
  </g>
  <text x="250" y="88" font-size="13" font-weight="700" fill="#1D9E75" text-anchor="middle" font-family="system-ui,sans-serif" opacity="0">2 à droite, 1 en haut<animate attributeName="opacity" values="0;0" dur="0.05s" begin="cp951play1.click" fill="freeze"/><animate attributeName="opacity" values="0;1" dur="0.3s" begin="cp951play1.click+1.6s" fill="freeze"/></text>
  <!-- trajet C -> D (orange, le même) -->
  <g opacity="0">
    <polyline points="67,122 119,122 119,104" fill="none" stroke="#B45309" stroke-width="2.4" stroke-dasharray="5 3"/>
    <path d="M119,97 L115,105 L123,105 Z" fill="#B45309"/>
    <animate attributeName="opacity" values="0;0" dur="0.05s" begin="cp951play1.click" fill="freeze"/>
    <animate attributeName="opacity" values="0;1" dur="0.3s" begin="cp951play1.click+3.6s" fill="freeze"/>
  </g>
  <text x="250" y="112" font-size="13" font-weight="700" fill="#B45309" text-anchor="middle" font-family="system-ui,sans-serif" opacity="0">encore 2 à droite, 1 en haut<animate attributeName="opacity" values="0;0" dur="0.05s" begin="cp951play1.click" fill="freeze"/><animate attributeName="opacity" values="0;1" dur="0.3s" begin="cp951play1.click+3.6s" fill="freeze"/></text>
  <!-- D apparaît -->
  <g opacity="0">
    <circle cx="119" cy="96" r="4.5" fill="#B45309"/>
    <text x="125" y="90" font-size="12" font-weight="700" fill="#B45309" font-family="system-ui,sans-serif">D</text>
    <animate attributeName="opacity" values="0;0" dur="0.05s" begin="cp951play1.click" fill="freeze"/>
    <animate attributeName="opacity" values="0;1" dur="0.3s" begin="cp951play1.click+5.6s" fill="freeze"/>
  </g>
  <!-- conclusions -->
  <g opacity="0">
    <rect x="20" y="192" width="8" height="8" rx="2" fill="#1D9E75"/>
    <text x="36" y="200" font-size="13" font-weight="600" fill="#0f172a" font-family="system-ui,sans-serif">Compte le trajet de A jusqu'au centre C.</text>
    <animate attributeName="opacity" values="0;0" dur="0.05s" begin="cp951play1.click" fill="freeze"/>
    <animate attributeName="opacity" values="0;1" dur="0.3s" begin="cp951play1.click+6.6s" fill="freeze"/>
  </g>
  <g opacity="0">
    <rect x="20" y="214" width="8" height="8" rx="2" fill="#B45309"/>
    <text x="36" y="222" font-size="13" font-weight="600" fill="#0f172a" font-family="system-ui,sans-serif">Continue le même trajet après C : voilà D.</text>
    <animate attributeName="opacity" values="0;0" dur="0.05s" begin="cp951play1.click" fill="freeze"/>
    <animate attributeName="opacity" values="0;1" dur="0.3s" begin="cp951play1.click+7.2s" fill="freeze"/>
  </g>
</svg>`.trim();

const CP_CONSTRUIRE_951 = {
    pages: [
        {
            titre: 'La méthode',
            svg: SVG_CONSTRUIRE_ANIM,
        },
    ],
};

// ── Où est le centre ? : la méthode du milieu en trois étapes (pas à pas, revue prof 2026-09-19) ──
// Étape 1 : la croix m, trajets 1 et 3 déséquilibrés, écartée (rouge). Étape 2 : la croix n,
// trajets 2 et 2, validée (vert). Étape 3 : la conclusion. Exemple hors situation : segment
// horizontal simple, les exercices tirent aussi des diagonales.
const SVG_MILIEU_PAS = `
<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 360 236" width="100%" style="max-width:380px;height:auto;display:block" role="img" data-etapes="3"
     aria-label="Un segment relie A à B sur un quadrillage, avec deux croix candidates m et n. En 3 étapes à faire défiler avec les flèches. Étape 1 : de A à m on compte 1 carreau, de m à B on en compte 3 : trajets inégaux, m n'est pas le centre. Étape 2 : de A à n on compte 2 carreaux, de n à B aussi 2 : n est le centre. Étape 3 : le centre est au milieu exact de A B, les deux moitiés du trajet doivent être égales">
  <text x="8" y="21" font-size="12.5" font-weight="600" fill="#dc2626" opacity="1" data-caption="1" font-family="system-ui,sans-serif">Je teste m : les deux trajets sont-ils égaux ?</text>
  <text x="8" y="21" font-size="12.5" font-weight="600" fill="#1D9E75" opacity="0" data-caption="2" font-family="system-ui,sans-serif">Je teste n : les deux trajets sont-ils égaux ?</text>
  <text x="8" y="21" font-size="12.5" font-weight="600" fill="#1E3A8A" opacity="0" data-caption="3" font-family="system-ui,sans-serif">Le centre est le milieu</text>
  <g data-etape="1" font-family="system-ui,sans-serif">
    <line x1="15" y1="44" x2="15" y2="174" stroke="#cbd5e1" stroke-width="1"/><line x1="15" y1="44" x2="145" y2="44" stroke="#cbd5e1" stroke-width="1"/>
    <line x1="41" y1="44" x2="41" y2="174" stroke="#cbd5e1" stroke-width="1"/><line x1="15" y1="70" x2="145" y2="70" stroke="#cbd5e1" stroke-width="1"/>
    <line x1="67" y1="44" x2="67" y2="174" stroke="#cbd5e1" stroke-width="1"/><line x1="15" y1="96" x2="145" y2="96" stroke="#cbd5e1" stroke-width="1"/>
    <line x1="93" y1="44" x2="93" y2="174" stroke="#cbd5e1" stroke-width="1"/><line x1="15" y1="122" x2="145" y2="122" stroke="#cbd5e1" stroke-width="1"/>
    <line x1="119" y1="44" x2="119" y2="174" stroke="#cbd5e1" stroke-width="1"/><line x1="15" y1="148" x2="145" y2="148" stroke="#cbd5e1" stroke-width="1"/>
    <line x1="145" y1="44" x2="145" y2="174" stroke="#cbd5e1" stroke-width="1"/><line x1="15" y1="174" x2="145" y2="174" stroke="#cbd5e1" stroke-width="1"/>
    <rect x="15" y="44" width="130" height="130" fill="none" stroke="#1E3A8A" stroke-width="1.4"/>
    <line x1="15" y1="96" x2="119" y2="96" stroke="#1E3A8A" stroke-width="2.2"/>
    <circle cx="15" cy="96" r="4.5" fill="#1E3A8A"/>
    <text x="10" y="88" font-size="12" font-weight="700" fill="#1E3A8A">A</text>
    <circle cx="119" cy="96" r="4.5" fill="#1E3A8A"/>
    <text x="124" y="88" font-size="12" font-weight="700" fill="#1E3A8A">B</text>
    <line x1="36" y1="91" x2="46" y2="101" stroke="#dc2626" stroke-width="2"/><line x1="36" y1="101" x2="46" y2="91" stroke="#dc2626" stroke-width="2"/>
    <text x="41" y="84" font-size="12" font-weight="700" fill="#dc2626" text-anchor="middle">m</text>
    <line x1="62" y1="91" x2="72" y2="101" stroke="#dc2626" stroke-width="2"/><line x1="62" y1="101" x2="72" y2="91" stroke="#dc2626" stroke-width="2"/>
    <text x="67" y="84" font-size="12" font-weight="700" fill="#dc2626" text-anchor="middle">n</text>
    <!-- test de m : 1 carreau contre 3 -->
    <line x1="15" y1="108" x2="41" y2="108" stroke="#dc2626" stroke-width="3"/>
    <line x1="41" y1="108" x2="119" y2="108" stroke="#dc2626" stroke-width="3" stroke-dasharray="5 3"/>
    <text x="250" y="66" font-size="13" font-weight="700" fill="#dc2626" text-anchor="middle">A → m : 1 carreau</text>
    <text x="250" y="88" font-size="13" font-weight="700" fill="#dc2626" text-anchor="middle">m → B : 3 carreaux</text>
    <text x="250" y="110" font-size="13" font-weight="700" fill="#dc2626" text-anchor="middle">1 ≠ 3 : m n'est pas le centre</text>
  </g>
  <g data-etape="2" font-family="system-ui,sans-serif">
    <!-- test de n : 2 et 2, sur une ligne sous les trajets rouges -->
    <line x1="15" y1="118" x2="67" y2="118" stroke="#1D9E75" stroke-width="3"/>
    <line x1="67" y1="118" x2="119" y2="118" stroke="#1D9E75" stroke-width="3" stroke-dasharray="5 3"/>
    <text x="250" y="140" font-size="13" font-weight="700" fill="#1D9E75" text-anchor="middle">A → n : 2, et n → B : 2</text>
    <text x="250" y="162" font-size="13" font-weight="700" fill="#1D9E75" text-anchor="middle">2 = 2 : n est le centre</text>
  </g>
  <g data-etape="3" font-family="system-ui,sans-serif">
    <rect x="20" y="196" width="8" height="8" rx="2" fill="#1D9E75"/>
    <text x="36" y="204" font-size="13" font-weight="600" fill="#0f172a">Le centre est au milieu exact de [AB].</text>
    <rect x="20" y="218" width="8" height="8" rx="2" fill="#B45309"/>
    <text x="36" y="226" font-size="13" font-weight="600" fill="#0f172a">Les deux moitiés du trajet doivent être égales.</text>
  </g>
</svg>`.trim();

const CP_MILIEU_951 = {
    pages: [
        {
            titre: 'La méthode',
            svg: SVG_MILIEU_PAS,
        },
    ],
};

// ── Caractères à centre de symétrie (règle sobre, décision utilisateur 2026-08-13) ──
const CP_CHIFFRES_951 = {
    pages: [
        {
            titre: 'La méthode',
            lignes: [
                'Imagine le chiffre écrit sur une feuille que tu fais tourner d\'un demi-tour, tête en bas.',
                'Lis ce qui apparaît : c\'est ta réponse.',
            ],
        },
    ],
};

const CP_951 = {
    construire_placer_points_2d: CP_CONSTRUIRE_951,
    // Entrée partagée : même méthode du trajet compté, on lit les coordonnées
    // de D au lieu de le pointer.
    coord_texte_trou_saisie: CP_CONSTRUIRE_951,
    // Page « méthode du milieu » : entrée CONSERVÉE, elle est aussi la fiche du
    // gen 1245 (cf. coupsDePouce/1245.js, cp951.centre_qcm_unique).
    centre_qcm_unique: CP_MILIEU_951,
    // La carte « chiffres et demi-tour » est devenue « Figures à centre de
    // symétrie » (lettres et chiffres, réponse « aucun » offerte) : même geste,
    // donc même fiche.
    caracteres_qcm_unique: CP_CHIFFRES_951,
    // Entrée partagée : même geste du trajet compté, appliqué à chaque
    // extrémité du segment avant de lire la lettre du nœud obtenu.
    image_grille_qcm_unique: CP_CONSTRUIRE_951,
};

export default CP_951;
